import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MensagemService, ProgressoService } from 'maestro-ng';
import { Pais } from '../pais.model';
import { PaisService } from '../pais.service';

@Component({
  selector: 'app-pais-visualizacao',
  templateUrl: './pais-visualizacao.component.html',
  styleUrls: ['./pais-visualizacao.component.css']
})
export class PaisVisualizacaoComponent implements OnInit {

  public pais: Pais;

  constructor(
    private route: ActivatedRoute,
    private progressoService: ProgressoService,
    private mensagemService: MensagemService,
    private paisService: PaisService,
  ) { }

  ngOnInit(): void {

    this.route.params.subscribe(params => {
      if (params['id']) {
        this.progressoService.modal();
        this.paisService.recuperarPorId(+params['id'])
          .then((pais) => this.carregarPais(pais))
          .catch(response => this.mensagemService.addErro('Erro ao carregar o país', response.error));
      }
    });
  }

  public carregarPais(pais: Pais) {
    this.pais = pais;
    this.progressoService.fechar();
  }
}
